<div class="error-message" [class.error-message--friendly]="friendlyError" *ngIf="message">{{message || emptyText}}</div>
<ng-container *ngIf="message$">
  <div class="error-message" [class.error-message--friendly]="friendlyError" *ngIf="message$ | async as message">
    {{message || emptyText}}
  </div>
</ng-container>
